import { createMakeStyles } from 'tss-react';
import { useTheme } from '@material-ui/core';

const { makeStyles } = createMakeStyles({ useTheme });

export const useStyles = makeStyles()((theme) => ({
  value: {
    fontWeight: 'bold',
    wordBreak: 'break-word',
    margin: 0,
  },

  label: {
    color: theme.palette.text.secondary,
    textTransform: 'uppercase',
    fontSize: '0.625rem',
    fontWeight: 'bold',
    letterSpacing: 0.5,
  },

  contentGrid: {
    maxHeight: '22rem',
    overflowY: 'auto',
  },
}));
